import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { Auth } from '../../model/auth.model';
import { AuthStoreService } from '../store/auth-store.service';
import { SegurosApiService } from './seguros-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private segurosService: SegurosApiService, 
    private authStore: AuthStoreService) { }

  login(usuario: string, password: string): Observable<Auth> {
    this.authStore.clearStorage(null);
    return this.segurosService.login(usuario, password).pipe(
      tap((auth: Auth) => this.authStore.handleAuthSuccess(auth, false)),
      catchError((error) => throwError(() => error))
    );
  }

  autologin(token: string): Observable<Auth> {
    return this.segurosService.autologin(token).pipe(
      tap((autenticacion: Auth) => this.authStore.handleAuthSuccess(autenticacion, false)),
      catchError((error) => throwError(() => error))
    );
  }

  suplantar(usuarioSuplantado: string): Observable<Auth> {
    return this.segurosService.suplantar(usuarioSuplantado).pipe(
      tap((auth: Auth) => this.authStore.handleAuthSuccess(auth, true)),
      catchError((error) => throwError(() => error))
    );
  }

  finSuplantar(): Observable<Auth> {
    return this.segurosService.finSuplantar().pipe(
      tap((auth: Auth) => {
        this.authStore.handleAuthSuccess(auth, false),
        this.authStore.clearSuplantado();
      }),
      catchError((error) => throwError(() => error))
    );
  }
}
